var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"screen-alert",style:({
    '--bg-color': _vm.$$FormData.background_color,
    '--cont-color': _vm.$$FormData.content_color,
    padding: `${_vm.$$FormData.vertical_margin}px ${_vm.$$FormData.horizontal_margin}px`
  })},[_c('div',{staticClass:"screen-alert__content"},[_c('div',{staticClass:"screen-alert__content-title"},[_vm._v(_vm._s(_vm.$$FormData.title))]),_c('div',{staticClass:"screen-alert__content-subtitle"},[_vm._v(_vm._s(_vm.$$FormData.subtitle))])]),_c('router-link',{staticClass:"screen-alert__btn",attrs:{"to":_vm.$$GetLinkValue(_vm.$$FormData.btn_link)}},[_vm._v(" "+_vm._s(_vm.$$FormData.btn_text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }